import { useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "@/App.css";
import SiteLayout from "@/components/SiteLayout";
import HeroSection from "@/components/HeroSection";
import FourPillars from "@/components/FourPillars";
import FocusAreas from "@/components/FocusAreas";
import OpenSourcingStatement from "@/components/OpenSourcingStatement";
import TradeCorridorStory from "@/components/TradeCorridorStory";
import TradeConversionBlock from "@/components/TradeConversionBlock";
import InsightsSection from "@/components/InsightsSection";
import EnquiryDialog from "@/components/EnquiryDialog";
import ProcessPage from "@/pages/ProcessPage";
import FocusAreasPage from "@/pages/FocusAreasPage";
import SectorDetailPage from "@/pages/SectorDetailPage";
import InsightsPage from "@/pages/InsightsPage";
import ArticlePage from "@/pages/ArticlePage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminInsightsPage from "@/pages/AdminInsightsPage";
import ProtectedRoute from "@/components/ProtectedRoute";
import SmoothScroll from "@/components/SmoothScroll";
import { AuthProvider } from "@/context/AuthContext";
import { processPages } from "@/data/processPages";
import { Toaster } from "@/components/ui/sonner";

function HomePage({ onEnquiry }) {
  return (
    <main id="top" data-testid="ugi-home-page">
      <HeroSection onEnquiry={onEnquiry} />
      <FourPillars />
      <TradeCorridorStory />
      <FocusAreas />
      <OpenSourcingStatement onEnquiry={onEnquiry} />
      <InsightsSection />
      <TradeConversionBlock onEnquiry={onEnquiry} />
    </main>
  );
}

function NotFoundPage() {
  return <main data-testid="not-found-page" className="mx-auto max-w-3xl px-5 py-32 text-center"><h1 className="font-serif text-5xl">Page not found.</h1><a href="/" className="mt-8 inline-flex border border-[#1C1613] px-6 py-4 text-xs font-bold tracking-[0.16em]">RETURN HOME</a></main>;
}

export default function App() {
  const [enquiryOpen, setEnquiryOpen] = useState(false);
  const openEnquiry = () => setEnquiryOpen(true);

  return (
    <div className="min-h-screen bg-[#FDFBF7] font-sans text-[#1C1613] antialiased">
      <AuthProvider>
        <BrowserRouter>
          <SmoothScroll />
          <Routes>
            <Route element={<SiteLayout onEnquiry={openEnquiry} />}>
              <Route path="/" element={<HomePage onEnquiry={openEnquiry} />} />
              <Route path="/source" element={<ProcessPage processKey="source" processData={processPages} onEnquiry={openEnquiry} />} />
              <Route path="/connect" element={<ProcessPage processKey="connect" processData={processPages} onEnquiry={openEnquiry} />} />
              <Route path="/facilitate" element={<ProcessPage processKey="facilitate" processData={processPages} onEnquiry={openEnquiry} />} />
              <Route path="/expand" element={<ProcessPage processKey="expand" processData={processPages} onEnquiry={openEnquiry} />} />
              <Route path="/focus-areas" element={<FocusAreasPage onEnquiry={openEnquiry} />} />
              <Route path="/focus-areas/:slug" element={<SectorDetailPage onEnquiry={openEnquiry} />} />
              <Route path="/insights" element={<InsightsPage />} />
              <Route path="/insights/:slug" element={<ArticlePage onEnquiry={openEnquiry} />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
            <Route path="/admin" element={<Navigate to="/admin/insights" replace />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin/insights" element={<ProtectedRoute><AdminInsightsPage /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <EnquiryDialog open={enquiryOpen} onOpenChange={setEnquiryOpen} />
      <Toaster position="top-center" richColors />
    </div>
  );
}
